import { Typography } from '@mui/material';
import React from 'react';
import { ILabelValuePanel } from '../Dashboard.model';

interface LabelValuePanelProps {
  panel: ILabelValuePanel;
}
function LabelValuePanel(props: LabelValuePanelProps) {
  const { panel } = props;
  return (
    <>
      <Typography variant="body2" color="text.secondary" gutterBottom>
        {panel.title}
      </Typography>
      <Typography variant="h4" component="div" sx={{ fontWeight: 'bold' }}>
        {panel.value}
      </Typography>
    </>
  );
}

export default LabelValuePanel;
